import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/app/curriculum/$curriculumId/edit')({
  component: lazyRouteComponent(() => import('./-edit')),
});
